import Vue from 'vue'
const routes = [
  {
    path: '/',
    name: 'index',
    meta:{ 
      title:'首页',
      activePath:'/',
      isManufacturer:false, // 是否是厂商
      keepAlive:false,
    },
    component: () => import('../views/home/index.vue')
  },
  {
    path: '/home',
    redirect:'/',
    name: 'home',
  },
  {
    path: '/caseExchange',
    name: 'caseExchange',
    meta:{
      title:'病例交流',
      activePath:'/caseExchange',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/caseExchange/index.vue')
  },
  {
    path: '/surgicalVideo',
    name: 'surgicalVideo',
    meta:{
      title:'手术视频',
      activePath:'/surgicalVideo',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/surgicalVideo/index.vue')
  },
  {
    path: '/internationalConference',
    name: 'internationalConference',
    meta:{
      title:'国际会议',
      activePath:'/internationalConference',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/internationalConference/index.vue')
  },
  {
    path: '/medicalInformation',
    name: 'medicalInformation',
    meta:{
      title:'医疗资讯',
      activePath:'/medicalInformation',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/medicalInformation/index.vue')
  },
  {
    path: '/aboutUs/teamIntroduction',
    name: 'teamIntroduction',
    meta:{
      title:'团队介绍',
      activePath:'/aboutUs',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/aboutUs/teamIntroduction.vue')
  },
  {
    path: '/aboutUs/contactUs',
    name: 'contactUs',
    meta:{
      title:'联系我们',
      activePath:'/aboutUs',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/aboutUs/contactUs.vue')
  },
  {
    path: '/aboutUs/businessPartner',
    name: 'businessPartner',
    meta:{
      title:'合作伙伴',
      activePath:'/aboutUs',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/aboutUs/businessPartner.vue')
  },
  {
    path: '/systemNotification',
    name: 'systemNotification',
    meta:{
      title:'系统通知',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/systemNotification/index.vue')
  },
  {
    path: '/individualCenter',
    name: 'individualCenter',
    meta:{
      title:'个人中心',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/individualCenter/index.vue')
  },
  {
    path: '/caseExchange/detail',
    name: 'caseExchangeDetail',
    meta:{
      title:'病例交流详情',
      activePath:'/caseExchange',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/caseExchange/detail/index.vue')
  },
  {
    path: '/surgicalVideo/videoFeature',
    name: 'videoFeature',
    meta:{
      title:'手术视频专题',
      activePath:'/surgicalVideo',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/surgicalVideo/videoFeature/index.vue')
  },
  {
    path: '/surgicalVideo/videoDetail',
    name: 'videoDetail',
    meta:{
      title:'手术视频详情',
      activePath:'/surgicalVideo',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/surgicalVideo/videoDetail/index.vue')
  },
  {
    path: '/medicalInformation/detail',
    name: 'medicalInformationDetail',
    meta:{
      title:'医疗资讯详情',
      activePath:'/medicalInformation',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/medicalInformation/detail/index.vue')
  },
  {
    path: '/internationalConference/detail',
    name: 'internationalConferenceDetail',
    meta:{
      title:'国际会议详情',
      activePath:'/internationalConference',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/internationalConference/detail/index.vue')
  },
  {
    path: '/aboutUs/teamIntroduction/detail',
    name: 'teamIntroductionDetail',
    meta:{
      title:'团队介绍详情',
      activePath:'/aboutUs',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/aboutUs/teamIntroductionDetail/index.vue')
  },
  {
    path: '/aboutUs/businessPartnerDetail',
    name: 'businessPartnerDetail',
    meta:{
      title:'合作伙伴详情',
      activePath:'/aboutUs',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/aboutUs/businessPartnerDetail/index.vue')
  },
  {
    path: '/systemNotificationDetail',
    name: 'systemNotificationDetail',
    meta:{
      title:'系统通知详情',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/systemNotification/detail/index.vue')
  },
  {
    path: '/individualCenter/pushCase',
    name: 'pushCase',
    meta:{
      title:'发布病例',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/individualCenter/case/pushCase.vue')
  },
  {
    path: '/individualCenter/pushVideo',
    name: 'pushVideo',
    meta:{
      title:'发布视频',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/individualCenter/video/pushVideo.vue')
  },
  {
    path: '/individualCenter/personalInformation',
    name: 'personalInformation',
    meta:{
      title:'个人信息',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/individualCenter/personalInformation/index.vue')
  },
  {
    path: '/individualCenter/fansList',
    name: 'fansList',
    meta:{
      title:'粉丝列表',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/individualCenter/fansList/index.vue')
  },
  {
    path: '/individualCenter/followList',
    name: 'followList',
    meta:{
      title:'关注列表',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/individualCenter/followList/index.vue')
  },
  {
    path: '/individualCenter/otherUser',
    name: 'otherUser',
    meta:{
      title:'用户资料',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/individualCenter/otherUser/index.vue')
  },
  {
    path: '/globalSearch',
    name: 'globalSearch',
    meta:{
      title:'搜索',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/globalSearch/index.vue')
  },
  {
    path: '/cooperativeManufacturer',
    name: 'cooperativeManufacturer',
    meta:{
      title:'合作厂家入驻',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/cooperativeManufacturer/index.vue')
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    meta:{
      title:'隐私协议',
      activePath:'/aboutUs',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/agreement/privacyAgreement.vue')
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    meta:{
      title:'免责声明',
      activePath:'',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/agreement/disclaimer.vue')
  },
  {
    path: '/pcVersion',
    name: 'pcVersion',
    meta:{
      title:'PC版手册',
      activePath:'/aboutUs',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/userManual/pcVersion.vue')
  },
  {
    path: '/mobileVersion',
    name: 'mobileVersion',
    meta:{
      title:'移动版手册',
      activePath:'/aboutUs',
      isManufacturer:false,
      keepAlive:false,
    },
    component: () => import('../views/userManual/mobileVersion.vue')
  },
  

  // 厂家身份
  {
    path: '/manufacturer',
    name: 'manufacturer',
    meta:{
      title:'合作厂家',
      activePath:'',
      isManufacturer:true,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/manufacturer/home/index.vue')
  },
  {
    path: '/manufacturer/editInfo',
    name: 'manufacturerEditInfo',
    meta:{
      title:'合作厂家信息编辑',
      activePath:'',
      isManufacturer:true,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/manufacturer/editInfo/index.vue')
  },
  {
    path: '/manufacturer/addProduct',
    name: 'manufacturerAddProduct',
    meta:{
      title:'合作厂家添加产品',
      activePath:'',
      isManufacturer:true,
      keepAlive:false,
      needLogin:true,
    },
    component: () => import('../views/manufacturer/addProduct/index.vue')
  },


  {
    path: '*',
    name: '404',
    meta:{
      title:'找不到页面了',
      activePath:'',
      keepAlive:false,
    },
    component: () => import('../views/404.vue')
  },
  {
    path: '/404',
    redirect:'*',
    name: '/404',
  },
]

export default routes